import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Header.module.scss';
import logo from '../../../images/login-logo-n.svg'
import dw from '../../../images/down-arrow.svg'
import { removeAuth } from '../../../utils/auth';

const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showDropdown, setShowDropdown] = useState(false);

    const navItems = [
        { name: 'Dashboard', path: '/dashboard' },
        { name: 'Alerts', path: '/alerts' },
        { name: 'Analytics', path: '/analytics' },
        { name: 'Reports', path: '/reports' }
    ];

    const handleLogout = () => {
        removeAuth(); // Remove both token and cookie
        navigate('/login');
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    return (
        <header className={`d-flex justify-content-between align-items-center px-4 py-3 ${styles.header}`}>
            <div className={styles.logo}>
                <img src={logo} alt="logo" />
            </div>

            <div className="d-flex align-items-center gap-4">
                <nav className={`d-flex gap-3 ${styles.navLinks}`}>
                    {navItems.map((item) => (
                        <button
                            key={item.name}
                            className={`btn ${styles.navButton}`}
                            style={{
                                backgroundColor: location.pathname === item.path ? '#023E58' : 'transparent',
                                border: 'none',
                                color: 'white'
                            }}
                            onClick={() => navigate(item.path)}
                        >
                            {item.name.toUpperCase()}
                        </button>
                    ))}
                </nav>

                <div className={`d-flex align-items-center gap-2 ${styles.userSection}`} onClick={toggleDropdown}>
                    <div className={styles.userIcon}>CF</div>
                    <div className={styles.userInfo} style={{ display: "flex" }}>
                        <div className={styles.username}>Chris Frank </div>
                        <div className={styles.userRole}>Telematics Expert</div>
                    </div>
                    <img src={dw} alt="downarrow" style={{ width: "20px" }} />
                    
                    {showDropdown && (
                        <div className={styles.dropdown}>
                            <button 
                                className={styles.dropdownItem}
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
